import { Component, inject, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { LogoutComplete } from '../../store/actions/auth.action';

@Component({
    selector: 'lib-logout-callback',
    template: ``
})
export class AuthLogoutCallbackComponent implements OnInit {

  store = inject(Store<any>);

  ngOnInit() {
    this.store.dispatch(new LogoutComplete({}));
  }
}
